var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouseOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_386_480)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_386_480",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_386_480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.43 17H10.57C10.25 17 10 16.7 10 16.32V12.04C10 11.8 10.11 11.58 10.28 11.46L13.71 9.09C13.89 8.97 14.11 8.97 14.29 9.09L17.72 11.46C17.9 11.58 18 11.8 18 12.04V16.32C18 16.69 17.74 17 17.43 17Z",
    fill: "#1E9B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.97 5H7.82C7.42 3.83 6.31 3 5 3C3.34 3 2 4.34 2 6V18C2 19.66 3.34 21 5 21C5.47 21 5.91 20.89 6.3 20.7C6.49 20.88 6.74 21 7.03 21H20.97C21.54 21 22 20.54 22 19.97V6.03C22 5.46 21.54 5 20.97 5ZM4 18C4 17.45 4.45 17 5 17C5.55 17 6 17.45 6 18C6 18.55 5.55 19 5 19C4.45 19 4 18.55 4 18ZM20 19H8V7H20V19Z",
    fill: "#1E9B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03 21H5C5.47 21 5.91 20.89 6.3 20.7C6.49 20.88 6.74 21 7.03 21Z",
    fill: "#1E9B6B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_386_480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseOn);
export default __webpack_public_path__ + "static/media/house_on.a5fc6f988853bcc56f44a158899e5f63.svg";
export { ForwardRef as ReactComponent };